import React, { Component } from 'react'
import { withRouter } from 'react-router'
import ContentBlock from '../ContentBlock'
import LoadingSpinner from './LoadingSpinner'

class PageLoader extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            isLoaded: false
        }

        this.timer;
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.showLoader()
        }
    }

    componentDidMount() {
        this.showLoader()
    }

    showLoader() {
        this.setState({
            isLoading: true,
            isLoaded: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    isLoaded: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            isLoading: false,
                            isLoaded: false
                        })
                    }, 300)
                })
            }, 300)
        })
    }

    render() {
        const { isLoading, isLoaded } = this.state

        if (!isLoading) {
            return null
        }

        return (
            <ContentBlock className={`content-block content-block--page-loader ${isLoaded ? 'content-block--hidden' : ''}`}>
                <LoadingSpinner />
            </ContentBlock>
        )
    }
}

export default withRouter(PageLoader)


// WEBPACK FOOTER //
// ./src/components/Global/PageLoader.js